import { actorSchema } from "@-/dev.improve.haniverse.database.schemas.actor.schema";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { ensureUserCardRows } from "@-/dev.improve.haniverse.lib.cards.user-card.rows";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { eq } from "@-/com.npmjs.drizzle-orm";

export function useUpsertGraphemeMeaningCard() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);

  return useMutation({
    mutationFn: async (input: { description: string; grapheme: string }): Promise<void> => {
      await actorDb(import.meta.location).transaction(async (tx) => {
        const { ids } = await ensureUserCardRows(
          tx,
          { grapheme: input.grapheme, kind: "meaning" },
          new Date().toISOString(),
        );
        // The mnemonic is an UPDATE of the card's row, never part of the insert that creates it,
        // so it reaches the cloud as a change to this one column.
        await tx
          .update(actorSchema.userGraphemeMeaningCard)
          .set({ description: input.description })
          .where(eq(actorSchema.userGraphemeMeaningCard.id, ids.detailId));
      });
    },
    mutationKey: ["upsertGraphemeMeaningCard"],
  });
}
